import axios from 'axios';
import { useEffect, useRef } from 'react';

import { getInjector, getRootScope } from '@/services/angularjs-bridge';

const ItemPublicationsStatus = ({ primaryKey }: { primaryKey: string }) => {

    const ref = useRef<HTMLDivElement>(null);

    const $angularJsInjector = getInjector();
    const $rootScope = getRootScope($angularJsInjector);
    const $controller = $angularJsInjector.get('$controller');
    const $compile = $angularJsInjector.get('$compile');
    const $templateCache = $angularJsInjector.get('$templateCache');

    useEffect(() => {

        (async function() {

            if (!ref || !ref.current) {
                return;
            }

            // Prepare a new scope for the history tab
            const $scope = $rootScope.$new();
            $scope.item = {
                primaryKey__: primaryKey,
            };

            // Prepare the history tab template
            const templateUrl = 'tpl/editor/publication-status.tpl.html';
            let $template = $templateCache.get(templateUrl);
            if (!$template) {
                $template = (await axios.get(templateUrl)).data;
                // Let's cache the template for further use in the current session
                $templateCache.put(templateUrl, $template);
            }

            //Prepare the controller
            $controller('PublicationStatusController', {
                $scope: $scope,
                $element: ref.current,
            });

            // Compile the template and attach the $scope to it
            const compileResult = $compile($template)($scope);
            //@ts-ignore
            angular.element(ref.current).append(compileResult);

            $rootScope.$evalAsync();

        })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    return (
        <div className="tw-h-full tw-flex-1 tw-flex tw-flex-col" ref={ref}></div>
    );
};

export { ItemPublicationsStatus };
